import { useState } from 'react';

import { Button } from '@flipster/react/design-system/button';
import { Toggle } from '@flipster/react/design-system/toggle';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { getFlags, updateFlagsAndReload, type Flags } from '../../../flag';

export const FeatureFlag = () => {
  const [flags, setFlags] = useState<Flags>(getFlags());
  const [dirty, setDirty] = useState<boolean>(false);

  return (
    <div className={stack({ flex: 1, align: 'stretch', gap: 8, overflowY: 'auto' })}>
      <h2 className={hstack({ gap: 16, textStyle: 'Title/XS' })}>
        <span>Feature Flags</span>
        <Button
          hierarchy='primary'
          color='accent'
          size='small'
          label='Apply & Reload'
          disabled={!dirty}
          onClick={() => updateFlagsAndReload(flags)}
        />
      </h2>
      <ul className={css({ flex: 1, p: 8, rounded: 4, bgColor: 'background.default.level-0' })}>
        {Object.entries(flags).map(([key, value]) => (
          <li className={hstack({ py: 4, gap: 8 })} key={key}>
            <label className={hstack({ gap: 12 })}>
              <Toggle
                selected={value}
                onChange={() => {
                  setDirty(true);
                  setFlags((prevState) => ({ ...prevState, [key]: !prevState[key] }));
                }}
              />
              <span className={css({ textStyle: 'Text/L/Monospace/Strong' })}>{key}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};
